import React from "react";

const Campaign = ({ fill }) => (
  <svg
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    width="22.5"
    height="25.514"
    viewBox="0 0 22.5 25.514"
  >
    <g id="megaphone_1_" data-name="megaphone (1)" transform="translate(-30.599 0.25)">
      <g id="Group_9985" data-name="Group 9985" transform="translate(30.849 0.933)">
        <g id="Group_9984" data-name="Group 9984">
          <path
            id="Path_1857"
            data-name="Path 1857"
            d="M51.18,28.029,42.891,19.74a2.2,2.2,0,0,0-3.376,2.784l-.012.058A15.336,15.336,0,0,1,35.3,30.444l-3.8,3.8a2.2,2.2,0,0,0,0,3.108l2.072,2.072a2.2,2.2,0,0,0,3.108,0l.518-.518,3.626,3.626a2.2,2.2,0,1,0,3.108-3.108l-1.554-1.554.518-.518a2.2,2.2,0,0,0,0-3.108l-.352-.352a15.338,15.338,0,0,1,5.8-2.477l.058-.012a2.2,2.2,0,0,0,2.783-.268h0A2.2,2.2,0,0,0,51.18,28.029ZM35.638,38.39a.732.732,0,0,1-1.036,0L32.53,36.318a.732.732,0,0,1,0-1.036l3.626-3.626,3.108,3.108Zm7.253,2.072A.733.733,0,1,1,41.855,41.5l-3.626-3.626,1.036-1.036ZM40.3,35.8c.22-.22.55-.558,1.07-1l.484.484a.732.732,0,0,1,0,1.036l-.518.518Zm.031-2.041-3.171-3.171a16.777,16.777,0,0,0,3.567-6.794l6.4,6.4A16.777,16.777,0,0,0,40.332,33.759ZM50.143,30.1a.732.732,0,0,1-1.036,0l-8.289-8.289a.733.733,0,0,1,1.036-1.036l8.289,8.289A.734.734,0,0,1,50.143,30.1Z"
            transform="translate(-30.849 -19.098)"
            // stroke="#000"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <g id="Group_9987" data-name="Group 9987" transform="translate(34.387 15.867)">
        <g id="Group_9986" data-name="Group 9986" transform="translate(0)">
          <path
            id="Path_1858"
            data-name="Path 1858"
            d="M105.553,324.977a.733.733,0,0,0-1.036,0l-1.036,1.036a.733.733,0,1,0,1.036,1.036l1.036-1.036A.733.733,0,0,0,105.553,324.977Z"
            transform="translate(-103.266 -324.762)"
            // stroke="#000"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <g id="Group_9989" data-name="Group 9989" transform="translate(45.523)">
        <g id="Group_9988" data-name="Group 9988" transform="translate(0)">
          <path
            id="Path_1859"
            data-name="Path 1859"
            d="M331.927,0a.733.733,0,0,0-.733.733V2.2a.733.733,0,0,0,1.465,0V.733A.733.733,0,0,0,331.927,0Z"
            transform="translate(-331.194)"
            // stroke="#000"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <g id="Group_9991" data-name="Group 9991" transform="translate(49.919 5.861)">
        <g id="Group_9990" data-name="Group 9990" transform="translate(0)">
          <path
            id="Path_1860"
            data-name="Path 1860"
            d="M423.367,119.966H421.9a.733.733,0,1,0,0,1.465h1.465a.733.733,0,0,0,0-1.465Z"
            transform="translate(-421.169 -119.966)"
            // stroke="#000"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <g id="Group_9993" data-name="Group 9993" transform="translate(48.454 1.465)">
        <g id="Group_9992" data-name="Group 9992">
          <path
            id="Path_1861"
            data-name="Path 1861"
            d="M393.894,30.206a.733.733,0,0,0-1.036,0l-1.465,1.465a.733.733,0,0,0,1.036,1.036l1.465-1.465A.733.733,0,0,0,393.894,30.206Z"
            transform="translate(-391.178 -29.991)"
            // stroke="#000"
            strokeWidth="0.5"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Campaign;
